<div class="mt-2 ml-3 mr-3 pt-2">
  <div class="flex justify-content-between col-12 bg-white btn-with-links p-3">
    <label class="font-semibold uppercase" translate>site.lbl_delivery_address</label>
    <p-button class="flex align-items-center justify-content-center" icon="pi pi-plus" label="Add Delivery Address"
      (click)="onAdd()"></p-button>
  </div>
  @if(data){
  <app-mi-table
    [collectionOfColumns]="allColumns"
    [attributeLabels]="filterAttributeLabels"
    [data]="tableData"
    entityName="site_delivery_address"
    [isLoading]="isLoading"
    (onPageChange)="onPageChange($event)"
    (itemPerPageChange)="itemPerPageChange($event)"
    [totalRecords]="totalRecords"
    [itemsPerPage]="itemsPerPage"
    [message]="deleteVehicleMsg"
    [header]="deleteVehicleHeaderMsg"
    (onDelete)="onVehicleDelete($event)"
    (onBulkDataDeleteEvent)="onBulkDataDeleteEvent($event)"
    [filterList]="filterList"
    (onValueChange)="onFilterValueChange($event)"
    [filterFields]="filterFieldsArray"
    [label]="btnLabel"
    (onBtnClick)="onAddVehicle()"
    [bulkUpdateLabel]="bulkUpdateLabel"
    [bulkDeleteLabel]="bulkDeleteLabel"
    [attributeData]="attributeData"
    (onBulkDataUpdateEvent)="onBulkDataUpdateEvent($event)"
    (onSearchValueChange)="onSearchValueChanges($event)"
    (onUpdate)="onUpdateVehicle($event)"
    [rowItems]="rowItems"
    [bulkSelectionsItems]="bulkSelectionsItems"
    (setCurrentRowData)="setCurrentRowData($event)"
    [visiblePrintLabel]="visiblePrintLabel"
    [showBulkUpdateDialog]="showBulkUpdateDialog"
    (onToggleOverLay)="showBulkUpdateDialog = false; visiblePrintLabel = false"
    [visible]="visible"
    [bulkUpdateHeader]="bulkUpdateHeader"
    [reviewHeader]="reviewHeader"
    [btnUpdate]="btnUpdate"
    (onSortData)="onSortData($event)">
  </app-mi-table>
  }
</div>

@if(isSiteReady) {
<p-dialog
  [header]="headerLabel"
  [modal]="true" [(visible)]="showAddDialog" [style]="{ width: '60rem' }">
  @if (showAddDialog) {
  <app-add-delivery-address
    [siteEntityId]="siteEntityId"
    [siteAddressId]="deliveryAddressId"
    [recordCount]="totalRecords"
    (saveSuccess)="onSaveSuccess()">
  </app-add-delivery-address>
  }
</p-dialog>
}